<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName"   clearable></el-input>
            </el-form-item>
            <el-form-item label="审核状态：">
                <el-select v-model="searchForm.authState" clearable>
                    <el-option value="1" label="待审核"></el-option>                    
                    <el-option value="2" label="拒绝"></el-option>
                    <el-option value="3" label="通过"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核时间：">
                <el-date-picker v-model="searchForm.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getUsersAuthListHandler">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >    
            <el-table-column prop="nickname" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="联系号码"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称"></el-table-column>
            <el-table-column prop="authStateNick" label="审核状态"></el-table-column>
            <el-table-column prop="createTime" label="提交时间"></el-table-column>
            <el-table-column prop="authTime" label="审核时间"></el-table-column>
             <el-table-column prop="countAuth" label="认证次数"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.authState == 1" type="text" @click="showVerify(scope.row)">审核</el-button>
                    <el-button v-else type="text" @click="showVerify(scope.row)">查看</el-button>
                     <el-button  type="text" @click="authCount(scope.row)">重置认证次数</el-button>
                </template>    
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>   
        <el-dialog :append-to-body="true"  title="身份认证审核" :visible.sync="verifiedVisible" width="600px" class="verifiedDialog" @close="cancel" :close-on-click-modal="false">
            <el-form label-width="120px" :model="verifiedInfo" ref="verifiedInfo">
                <el-form-item label="姓名：">
                    <span>{{ verifiedInfo.nickname }}</span>
                </el-form-item>
                <el-form-item label="联系号码：">
                    <span>{{ verifiedInfo.phone }}</span>
                </el-form-item>
                <el-form-item label="代理商名称：">
                    <span>{{ verifiedInfo.agentName }}</span>
                </el-form-item>
                <el-form-item label="身份证号：">
                    <span>{{ verifiedInfo.cardCode }}</span>
                </el-form-item >
                <el-form-item label="图片：">
                    <el-image class="img-defined" :src="verifiedInfo.headerUrl" 
                    :preview-src-list="[verifiedInfo.headerUrl]" alt=""></el-image >

                    <el-image  class="img-defined"  :src="verifiedInfo.backHeaderUrl"
                    :preview-src-list="[verifiedInfo.backHeaderUrl]" alt=""></el-image >

                    <el-image  class="img-defined"  :src="verifiedInfo.handheldUrls"
                    :preview-src-list="[verifiedInfo.handheldUrls]" alt=""></el-image >
                </el-form-item>
                   <el-form-item label="备注：" prop="remark">
                        <el-input v-model.trim="verifiedInfo.remark" clearable></el-input>
                    </el-form-item> 
                <el-form-item v-if="showVerifyLable" label="审核：">
                    <el-select v-model="verifiedInfo.authState">
                        <el-option value="2" label="拒绝"></el-option>
                        <el-option value="3" label="通过"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureVerify">确 定</el-button>
            </div> 
        </el-dialog>    
    </div>
</template>
<script>
import {getUsersAuthList, userVerified,agentVerified,getAGentAuthList,subAuth} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                authState: '',
                iccid: '',
                time: null,
                agentName:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            verifiedVisible: false,
            verifiedInfo: {
                id: '',
                nickname: '',
                phone: '',
                iccid: '',
                cardCode: '',
                headerUrl: '',
                backHeaderUrl: '',
                handheldUrls: '',
                authState: '2',
                agentName:'',
                agentId:'',
                countAuth:'',
                remark:''
            },
            verifiedSrcList:[],//图片放大预览列表
            showVerifyLable: true            
        }
    },
    methods: {
        cancel(){
            this.verifiedVisible = false;    
            this.$refs.verifiedInfo.resetFields();  
        },
        getUsersAuthListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getAGentAuthList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },      
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        showVerify(row){
            this.verifiedVisible = true;
            for(var key in this.verifiedInfo){
                this.verifiedInfo[key] = row[key];
                this.showVerifyLable = row.authState == 1 ? true : false;
                this.verifiedInfo['authState'] = '3';
                this.verifiedInfo.headerUrl = process.env.VUE_APP_IMG_URL + '/' + row['headerUrl'];
                this.verifiedInfo.backHeaderUrl = process.env.VUE_APP_IMG_URL + '/' + row['backHeaderUrl'];
                this.verifiedInfo.handheldUrls = process.env.VUE_APP_IMG_URL + '/' + row['handheldUrls'];
            }

            this.verifiedSrcList[0] = this.verifiedInfo.headerUrl;
            this.verifiedSrcList[1] = this.verifiedInfo.backHeaderUrl;
            this.verifiedSrcList[2] = this.verifiedInfo.handheldUrls;

        },  
        sureVerify(){
            var data = {
                id: this.verifiedInfo.id,
                authState: this.verifiedInfo.authState,
                remark:this.verifiedInfo.remark
            }
            agentVerified(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success('审核完成！');
                    this.getUsersAuthListHandler();
                    this.verifiedVisible = false;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
         authCount(row){
            var data = {
                agentId: row.agentId,
                authState: this.verifiedInfo.authState
            }
            subAuth(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success('重置成功！');
                    this.getUsersAuthListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getUsersAuthListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getUsersAuthListHandler();
        }  
    },
    created () {
        this.getUsersAuthListHandler();
    } 
}
</script>
<style lang="less" scoped>
.verifiedDialog {
    .img-defined {
        width: 140px;
        height: 100px;
        margin-left: 10px;
        &:first-child {
            margin-left: 0;
        }
        
    }

}
</style>

